import React, { Component } from "react";
import { Form, Input, Button, Layout, Space, Spin } from "antd";
import ApplicationService from "services/application";

export default class LoginPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  onSubmit = async (values) => {
    try {
      this.showLoader();
      await ApplicationService.login(values);
    } catch (err) {
      console.log("err", err);
    } finally {
      this.hideLoader();
    }
  };

  showLoader = () => this.setState({ loading: true });

  hideLoader = () => this.setState({ loading: false });

  render() {
    return (
      <Layout>
        <Space style={{ height: "100vh" }} direction="vertical" align="center">
          <Layout.Header style={{backgroundColor: "#fff"}}>Amicusmeus</Layout.Header>
          {this.state.loading && <Spin size="large" fullscreen />}
          <Form name="basic" onFinish={this.onSubmit}>
            <Form.Item
              label="Username"
              name="email"
              rules={[
                { required: true, message: "Please input your username!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </Layout>
    );
  }
}
